import type { Dayjs } from '@/config/dayjs';
import type { DateRangeShortcut } from './DateRange';

export function capShortcutsAt(
  shortcuts: DateRangeShortcut[],
  maxDate: Dayjs | undefined,
): DateRangeShortcut[] {
  if (!maxDate) return shortcuts;
  return shortcuts.map((shortcut) => ({
    label: shortcut.label,
    getValue: () => {
      const [start, end] = shortcut.getValue();
      return [start, end.isAfter(maxDate, 'day') ? maxDate : end];
    },
  }));
}
